<template>
    <div class="">
        <div class="filter_row text_center  pa10">
            <table class="ucc_select_table">
                <tr>
                    <th>검출 1회 이용요금</th>
                    <td>
                        <el-input v-model="point" @input="parentChange('point',point)" maxLength="20"></el-input>

                    </td>
                </tr>
                        <div class="input_error" v-if="validation.hasError('point')">{{ validation.firstError('point') }}</div>
                 </table>
        </div>
    </div>
</template>

<script>
import util from "@/mixins/util";
import dateMixins from "@/mixins/dateMixins";
import pointValidator from "@/mixins/validators/pointValidator";
import EventBus from "@/utils/event-bus";
export default {
    name: "PointWriteServiceLayout",
    mixins: [pointValidator, dateMixins],
    components: {},
    inject: ['pointWriteSetData'],
    provide() {
        return {}
    },
    props: {
        pointData: {
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    data() {
        return {

        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        EventBus.$on('PointWriteDefaultLayoutValidator', this.checkValidator);
        if (this.hasData()) {
            this.initSetData();
        }
    },
    beforeDestroy() {
        EventBus.$off('PointWriteDefaultLayoutValidator');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initSetData() {
            this.point = this.pointData.pd_point;
            this.parentChange('point', this.point);
        },
        parentChange(key, value) {
            this.pointWriteSetData(key, value)
        },
        checkValidator(dataArr) {
            this.$validate(dataArr)
        },
        hasData() {
            return !util.isEmpty(this.pointData);
        },

    },
    watch: {},
}
</script>

<style scoped>

</style>
